"use client";
import clsx from "clsx";
import { type Control, type FieldValues, type Path, useController } from "react-hook-form";
import "react-phone-number-input/style.css";
import ReactPhoneNumberInput from "react-phone-number-input";
import fr from "react-phone-number-input/locale/fr.json";

type Props<T extends FieldValues> = {
  id: string;
  label: string;
  name: Path<T>;
  control: Control<T>;
  placeholder?: string;
  className?: string;
  labelClassName?: string;
  inputClassName?: string;
  disabled?: boolean;
  variant?: "primary" | "secondary";
  readOnly?: boolean;
  numberClassName?: string;
};
export const PhoneInput = <T extends FieldValues>({
  id,
  label,
  name,
  control,
  placeholder,
  className,
  inputClassName,
  labelClassName,
  numberClassName,
  variant = "primary",
  disabled = false,
  readOnly = false,
}: Props<T>) => {
  const {
    field,
    fieldState: { error },
  } = useController({ name, control });

  return (
    <div className={className}>
      <label
        htmlFor={id}
        className={clsx("text-xs font-normal font-sans", labelClassName, {
          "text-[#C92A2A]": error,
          "text-[#22201F]": !error,
        })}
      >
        {label}
      </label>
      <div
        className={clsx(
          "rounded-lg border py-3 px-4 w-full text-base font-normal placeholder:text-tx-2 flex items-center space-x-1 relative",
          inputClassName,
          {
            "text-no border-no": error,
            "text-tx-1 border-bg-2": !error,
            "bg-bg-1": variant === "secondary",
            "bg-white": variant === "primary",
          },
        )}
      >
        <ReactPhoneNumberInput
          placeholder={placeholder || undefined}
          defaultCountry="FR"
          countryOptionsOrder={["FR", "BE", "CH"]}
          labels={fr}
          readOnly={readOnly}
          numberInputProps={{
            className: clsx(
              "autofill:shadow-bg-white border-none min-w-[214px] focus:outline-hidden pl-1 w-full",
              numberClassName,
              {
                "bg-white": variant === "primary",
                "bg-bg-1": variant === "secondary",
              },
            ),
            id,
          }}
          value={field.value}
          onChange={(v) => field.onChange(v || "")}
          onBlur={field.onBlur}
          ref={field.ref}
          className={clsx("flex flex-nowrap w-full focus:outline-hidden", inputClassName, {
            "bg-white": variant === "primary",
            "bg-bg-1": variant === "secondary",
          })}
          disabled={field.disabled}
        />
        {/* <span className="absolute w-4 h-4 right-2 top-1/2 -translate-y-1/2 z-30">
          <PhoneIcon className="w-4 h-4 text-tx-2" />
        </span> */}
      </div>
      {/* {error?.message && <p className="text-[#C92A2A] text-xs leading-5 mt-1">{error.message}</p>} */}
    </div>
  );
};
